import { z } from 'zod';
import { FlowKind, FlowState } from './enums.js';
import { FlowPricingMode } from './pricingMode.js';
import { FlowDefinitionState, FlowDefinitionWithFlowBasicSchema, } from '../flowDefinition/flowDefinition.js';
export const FlowTagSchema = z.object({
    name: z.string(),
    category: z.string().nullish(),
});
/**
 * A flow row as flow-api serves it: `Date` columns are ISO strings, and the joined
 * fields are optional because only some queries select them.
 */
export const FlowWithCreatedBySchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    name: z.string(),
    description: z.string().nullable(),
    organizationId: z.string(),
    agentId: z.string().nullable(),
    state: z.enum(FlowState),
    kind: z.enum(FlowKind),
    createdById: z.string().nullable(),
    updatedById: z.string().nullable(),
    liveDefinitionId: z.string().nullable(),
    slug: z.string().nullable(),
    clonedFromFlowId: z.string().nullable(),
    pricingMode: z.enum(FlowPricingMode).nullable(),
    createdByEmail: z.string().nullish(),
    updatedByEmail: z.string().nullish(),
    agentName: z.string().nullish(),
    agentCategory: z.string().nullish(),
    tags: z.array(FlowTagSchema).optional(),
});
export const FlowWithRunCountSchema = FlowWithCreatedBySchema.extend({
    runCount: z.number(),
    mostRecentRunAt: z.iso.datetime().optional(),
    /** Only populated when the request asks for `includeFlowDefinitionStates`. */
    flowDefinitionStates: z.array(z.enum(FlowDefinitionState)).optional(),
});
export const FlowWithDefinitionsSchema = z.object({
    flow: FlowWithCreatedBySchema,
    flowDefinitions: z.array(FlowDefinitionWithFlowBasicSchema),
});
//# sourceMappingURL=flow.js.map